"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METRICS_DESTINATIONS = exports.TRIGGER = exports.METRIC_TYPE = void 0;
exports.METRIC_TYPE = {
    PAGE_LOAD: 'page_load'
};
exports.TRIGGER = {
    BROWSER_OR_APP_LOAD: 'browser_or_app_load',
    ROUTE_CHANGE: 'route_change',
    ROUTE_CHANGE_ERROR: 'route_change_error',
    PAGE_SUBSEQUENT_LOAD: 'page_subsequent_load',
    POST_LOAD_ERROR: 'post_load_error'
};
exports.METRICS_DESTINATIONS = Object.freeze({
    NEW_RELIC: 'newrelic',
    DATA_DOG: 'datadog'
});
